import DisclosureButton from './DisclosureButton'
import DisclosureContent from './DisclosureContent'

export default {
  DisclosureButton,
  DisclosureContent,
}
